"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntegrationData = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const AccountProvider_1 = require("../../AccountProvider");
const selectors_1 = require("../selectors");
const slice_1 = require("../slice");
const selectors_2 = require("../selectors");
/*
  Common hooks helps to encapsulate logic for getting integration tokens
*/
const useIntegrationData = ({ gameVendor, }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountId = (0, react_redux_1.useSelector)(AccountProvider_1.selectAccountId);
    const { loading: tokenLoading, error } = (0, react_redux_1.useSelector)((s) => (0, selectors_1.selectFetchVirtualGameTokenRequest)(s, gameVendor));
    const token = (0, react_redux_1.useSelector)((s) => { var _a; return (_a = (0, selectors_2.selectVirtualGameToken)(s, gameVendor)) === null || _a === void 0 ? void 0 : _a.token; });
    const { loading: userLoading } = (0, react_redux_1.useSelector)(AccountProvider_1.selectFetchUserRequest);
    const user = (0, react_redux_1.useSelector)(AccountProvider_1.selectAccountUser);
    (0, react_1.useEffect)(() => {
        if (accountId && !token) {
            dispatch(slice_1.virtualGamesProviderActions.getToken({ accountId, gameVendor }));
        }
    }, [dispatch, accountId, token, gameVendor]);
    const noUser = userLoading === false && !user; // We can show virtual game for non authenticated user
    const tokenLoaded = !!user && tokenLoading === false && (!!token || !!error); // User authenticated and token or error exists
    const loaded = noUser || tokenLoaded;
    const resetToken = (0, react_1.useCallback)(() => {
        dispatch(slice_1.virtualGamesProviderActions.resetVirtualGameState({ gameVendor }));
    }, [dispatch, gameVendor]);
    const refreshToken = (0, react_1.useCallback)(() => {
        if (accountId) {
            dispatch(slice_1.virtualGamesProviderActions.getToken({ accountId, gameVendor }));
        }
    }, [accountId, dispatch, gameVendor]);
    return (0, react_1.useMemo)(() => ({
        loaded,
        error,
        token,
        refreshToken,
        resetToken,
    }), [error, loaded, token, refreshToken, resetToken]);
};
exports.useIntegrationData = useIntegrationData;
//# sourceMappingURL=useIntegrationData.js.map